import arriereBackoffice from '@avantstay/arriere-clients/dist/arriereBackoffice'

import { SaveBookingTagsParams } from '../../AddBookingTagsSidePanel.types'

export const getBookingTags = () => {
  return arriereBackoffice.queries.bookingTags({
    __alias: 'getBookingTags',
    description: true,
    id: {
      id: true,
      tagLevel: true,
    },
    hierarchy: true,
    manuallyApplicable: true,
    name: true,
  })
}

export const saveBookingTags = ({ bookingId, input }: SaveBookingTagsParams) => {
  return arriereBackoffice.mutations.bookingTagging({
    __alias: 'saveBookingTags',
    applyTags: {
      __args: {
        bookingId,
        input,
      },
    },
  })
}

export const getBookingWithTags = (bookingId: string) => {
  return arriereBackoffice.queries.booking({
    __alias: 'getBookingWithTags',
    __args: { bookingId },
    id: true,
    tags: {
      bookingTags: {
        short: true,
        full: {
          reason: true,
          tag: {
            id: {
              id: true,
              tagLevel: true,
            },
            name: true,
            hierarchy: true,
            manuallyApplicable: true,
          },
        },
      },
    },
  })
}

export const disableBookingTags = ({ bookingId, tagsIds }: { bookingId: string; tagsIds: number[] }) => {
  return arriereBackoffice.mutations.bookingTagging({
    __alias: 'disableBookingTags',
    disableTags: {
      __args: {
        bookingId,
        tagsIds,
      },
    },
  })
}
